"use strict";
function baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while (length--) {
        array[length] = array[length].value;
    }
    return array;
}
module.exports = baseSortBy;
//# sourceMappingURL=_baseSortBy.js.map